const localStore = {
  store: window.localStorage,//更换存储方式时，修改此对象即可
  separator: '.',
  userKey: '',
  preProcessors: [],//存数据的预处理函数
  postProcessors: [],//取数据的后处理函数

  setItem: function () {
    let ags = Array.from(arguments)
    let keyParts = ags.slice(0, ags.length - 1)
    const key = keyParts.join( this.separator)
    let value = ags[ags.length - 1]
    value = JSON.stringify(value)
    for (let i = 0; i <  this.preProcessors.length - 1; i++) {
      this.preProcessors[i].call(null, value)
    }
    this.store.setItem(key, value)
  },

  getItem: function () {
    let ags = Array.from(arguments)
    const key = ags.join( this.separator)
    let value =  this.store.getItem(key)
    try {
      //捕获对非json数据的处理异常
      value = JSON.parse(value)
    } catch (e) {
    }
    for (let i = 0; i <  this.postProcessors.length - 1; i++) {
      this.postProcessors[i].call(null, value)
    }
    return value
  },

  getItemAry: function(key) {
    return eval(this.store.getItem(key))
  },

  //加入历史搜索 最多存15个 - 存储形式为：数组字符串
  saveOrUpdateHistory: function(key, value) {
    if(value != '' && value != null) {
      let localValue = this.getItemAry(key)

      if (localValue != null) {
        let index = localValue.indexOf(value)
        if (index > -1) {
          localValue.splice(index, 1)
        }
        localValue.unshift(value)
      } else {
        let ary = new Array()
        ary.push(value)
        localValue = ary
      }

      if(localValue && localValue.length > 15) {
        localValue = localValue.slice(0, 15)
      }

      this.setItem(key, localValue)
    }
  },

  //加入历史搜索 最多存15个 - 存储形式为：数组对象（搜索词: 类型）
  saveOrUpdateHistoryQuery: function(key, value, type) {
    if(value != '' && value != null) {
      let localValue = this.getItemAry(key),
        newObj = new Object()
      newObj.text = value
      newObj.type = type

      if (localValue != null) {
        let index = -1
        localValue.forEach( function(item, ind) {
          if(item.text == value) index = ind
        })
        if (index > -1) {
          localValue.splice(index, 1)
        }
        localValue.unshift(newObj)
      } else {
        let ary = new Array()
        ary.push(newObj)
        localValue = ary
      }

      if(localValue && localValue.length > 15) {
        localValue = localValue.slice(0, 15)
      }

      this.setItem(key, localValue)
    }
  },

  /**
   * 处理字符串数据值
   * 1.去掉前后空格
   * 2.中间多空格改为一个
   */
  handleValueTrim(value){
    if(typeof value == 'string') {
      value = value.trim().replace(/\s+/g, ' ')
    }
    return value
  },

  //过滤不是对象类型的脏数据
  filterHistoryQuery(key){
    let localValueAry = this.getItemAry(key),
      localValue = []
    if(localValueAry != null) {
      localValue = localValueAry.filter(item => {
        return typeof item == 'object'
      })
    }
    if(localValue && localValue.length>0) {
      this.setItem(key, localValue)
    } else {
      this.removeByKey(key)
    }
  },

  removeByKey(key){
    this.store.removeItem(key)
  },

  clear: function () {
    this.store.clear()
  },

  remove: function () {
    let ags = Array.from(arguments)
    const key = ags.join( this.separator)
    this.store.removeItem(key)
  },

}

export default localStore



// WEBPACK FOOTER //
// ./src/utils/localStore.js